import PromoHeader from './PromoHeader';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getOnDemandLink } from 'state/Links/selectors';

export default connect(createStructuredSelector({ onDemandLink: getOnDemandLink }))(PromoHeader);
